import clsx from 'clsx'
import parse from 'html-react-parser'
import React from 'react'

import s from './styles.module.scss'

import { mainPictureByServiceProviderType } from './mainPictureByServiceProviderType'
import { BackgroundImage } from '../../../../atoms'
import { IServiceProvider } from '../../../../templates/house/house-services/house-services.type'
import { Rating } from '../../../rating/Rating'

interface IServiceHeaderProps {
  serviceProvider: IServiceProvider
  className?: string
  infosDisabled?: boolean
  recommended?: boolean
}

const ServiceHeader = ({
  serviceProvider,
  className,
  infosDisabled = false,
  recommended = false,
}: IServiceHeaderProps) => {
  return (
    <div className={clsx(s.serviceHeader, className)}>
      <div className={s.contentService}>
        <div className={s.imageService}>
          {serviceProvider.mainPicture ? (
            <BackgroundImage
              src={serviceProvider.mainPicture?.uri}
              style={{ borderRadius: '5px' }}
              type='cover'
              alt=''
            />
          ) : (
            <div className={s.emptyState}>
              {mainPictureByServiceProviderType(
                serviceProvider.category ?? undefined,
              )}
            </div>
          )}
        </div>
        <div className={s.containerInformations}>
          {!infosDisabled && (
            <>
              {recommended && (
                <div className={s.recommended}>Recommandé par l’hôte</div>
              )}
              <h4 className={s.name}>{serviceProvider.title}</h4>
              <Rating
                rating={serviceProvider.googleRating?.rating}
                userRatingsTotal={
                  serviceProvider.googleRating?.userRatingsTotal
                }
                className={{ container: s.rating }}
              />
              {serviceProvider.readableId && (
                <div className={s.readableId}>{serviceProvider.readableId}</div>
              )}
            </>
          )}
        </div>
      </div>
      {serviceProvider.description && (
        <div className={s.description}>
          {parse(serviceProvider.description)}
        </div>
      )}
    </div>
  )
}

export default ServiceHeader
